var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3346 14.9993C28.3346 22.3593 22.3613 28.3327 15.0013 28.3327C7.6413 28.3327 3.14797 20.9194 3.14797 20.9194M3.14797 20.9194H9.17464M3.14797 20.9194V27.586M1.66797 14.9993C1.66797 7.63935 7.58797 1.66602 15.0013 1.66602C23.8946 1.66602 28.3346 9.07935 28.3346 9.07935M28.3346 9.07935V2.41268M28.3346 9.07935H22.4146",
    stroke: "#C5CCD3",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIcon);
export default __webpack_public_path__ + "static/media/arrows_icon.fa2f74ed31682df68adeeaa4cb7cac2e.svg";
export { ForwardRef as ReactComponent };